module.exports = __webpack_public_path__ + "img/btn_map_c.2395dae7.png";